// extracted by mini-css-extract-plugin
module.exports = {"copyToken":"AnswerOverviewPage_copyToken__K5fGh"};